/* eslint-disable import/no-cycle */
import { useEffect } from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import dayjs from 'utils/dayjs';
import { setAppLocale } from 'actions/misc';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import { THERAPY_URL } from '../environment';
import { fetchUser } from '../actions/user';
import { signoutUser } from '../actions/auths';
import GlobalSnackbarMessage from '../components/global/SnackbarMessage';
import isClient from '../utils/isClient';
import { setDefaultTimezone } from '../utils/timezone';
import Navigation from './Navigation';

function AppLayout({
  authenticated = false,
  user,
  location: { pathname },
  children,
  fetchUser: fetchUserAction,
  setAppLocale: setAppLocaleAction,
  ldClient,
}) {
  const onAuthenticated = () => {
    fetchUserAction(response => {
      const fetchedUser = response.data;

      setAppLocaleAction(fetchedUser.locale);
      dayjs.locale(fetchedUser.locale);
      setDefaultTimezone(fetchedUser);

      if (isClient(fetchedUser.roles || [])) {
        localStorage.clear();
        window.location.href = `${THERAPY_URL}/`;
      } else {
        const kind = fetchedUser.roles.some(role => role.admin_yn === true)
          ? 'admin'
          : 'provider';
        const context = {
          key: fetchedUser.uuid,
          kind,
        };
        ldClient.identify(context);
      }
    });
  };

  useEffect(() => {
    if (authenticated) {
      onAuthenticated();
    }
  }, []);

  const hasProviderRole = user?.roles?.some(
    role => role.provider_yn === true,
  );
  const hasAdminRole = user?.roles?.some(role => role.admin_yn === true);

  // display blank page if they aren't an admin or a provider
  if (authenticated && !hasProviderRole && !hasAdminRole) {
    return <Box></Box>;
  }
  if (
    authenticated &&
    !pathname.includes('signup') &&
    !pathname.includes('signup_specialized')
  ) {
    return (
      <Box sx={{ display: 'flex' }}>
        <Navigation user={user} />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            paddingTop: '100px',
          }}
        >
          {children}
        </Box>
        <GlobalSnackbarMessage />
      </Box>
    );
  }
  return <Box component="main">{children}</Box>;
}

AppLayout.propTypes = {
  fetchUser: PropTypes.func.isRequired,
  authenticated: PropTypes.bool,
  setAppLocale: PropTypes.func.isRequired,
  children: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  ldClient: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    authenticated: state.auth.authenticated,
    user: state.user,
  };
}

export default withLDConsumer()(
  withRouter(
    connect(mapStateToProps, {
      fetchUser,
      signoutUser,
      setAppLocale,
    })(AppLayout),
  ),
);
